import { render, staticRenderFns } from "./customdomain.vue?vue&type=template&id=3ad6bee2&"
import script from "./customdomain.vue?vue&type=script&lang=js&"
export * from "./customdomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports